import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import WebData from "../../../../Helpers/WebData";
import { Form, Row, Col } from "react-bootstrap";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import "./DigitalVolunteerForm.css";

const DigitalVolunteerForm = () => {
  const [formData, setFormData] = useState({});
  const [wordCount, setWordCount] = useState(0);
  const [showSkills, setShowSkills] = useState(false);
  const skillsDropdown = useRef();
  const [cv, setcv] = useState();
  const [skills, setskills] = useState([]);
  const [change, setchange] = useState(false);
  const [success, setsuccess] = useState(false);
  const [name, setname] = useState();
  const digitalVolunteer = JSON.parse(localStorage.getItem("DigitalVolunteer"));
  const [loading, setloading] = useState(false);

  const formHandler = (e) => {
    let inputValue = e.target.value;
    if (e.target.name === "message" && inputValue.length <= 200) {
      setWordCount(inputValue.length);
    } else if (e.target.name === "message" && inputValue.length > 200) {
      return false;
    }
    setFormData({ ...formData, [e.target.name]: inputValue });
  };

  if (formData) {
    localStorage.setItem("DigitalVolunteer", JSON.stringify(formData));
  }

  useEffect(() => {
    if (digitalVolunteer) {
      setFormData(digitalVolunteer);
    }
  }, []);

  const phoneHandler = (v) => {
    setFormData({ ...formData, contact: v });
  };

  const submitDigitalVolunteerForm = async (event) => {
    event.preventDefault();
    var form = document.getElementById("digitalVolunteerForm");
    form.classList.add("was-validated");
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("contact", formData.contact);
      data.append("email", formData.email);
      data.append("country", parsePhoneNumber(formData.contact).country);
      data.append("duration", formData.duration);
      data.append("skills", skills.join(","));
      data.append("cv", cv);
      data.append("message", formData.message);
      data.append("type", "Digital Volunteer");
      axios
        .post("https://animal-ngo.herokuapp.com/application/send", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => alert(res.data))
        .catch((err) => alert(err.response.data));
    }
  };

  const handleClick = (e) => {
    if (!skillsDropdown.current?.contains(e.target)) {
      setShowSkills(false);
    }
  };

  window.addEventListener("mousedown", handleClick, false);
  window.addEventListener("scroll", () => {
    setShowSkills(false);
  });

  const skills_changed = (e) => {
    const parent = e.target.parentNode;
    var s = skills;
    if (e.target.checked) {
      s.push(
        parent.getElementsByClassName("custom-control-label")[0].textContent
      );
    } else {
      var index = s.indexOf(e.target.value);
      s.splice(index, 1);
    }
    setskills(s);
  };

  const change_file = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size <= 204800) {
        setcv(e.target.files[0]);
      } else {
        alert("file must be less then 200KB");
      }
    } else {
      setcv(null);
    }
  };

  return (
    <>
      <div className="form-wrapper">
        <div className="form-container scrollbar-hide form-container-gm">
          <Form
            onSubmit={submitDigitalVolunteerForm}
            className="needs-validation w-100"
            id="digitalVolunteerForm"
            noValidate
          >
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  type="text"
                  value={formData ? formData.name : ""}
                  name="name"
                  placeholder="Full Name*"
                  onChange={formHandler}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <PhoneInput
                  placeholder="00000 000000"
                  id="phone-input"
                  name="contact"
                  value={formData ? formData.contact : ""}
                  onChange={phoneHandler}
                  international
                  defaultCountry="IN"
                  countryCallingCodeEditable={false}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  type="email"
                  value={formData ? formData.email : ""}
                  name="email"
                  placeholder="Email*"
                  onChange={formHandler}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <label htmlFor="volunteerDuration" className="mb-1">
                  Duration*
                </label>
                <select
                  name="duration"
                  onChange={formHandler}
                  className="form-control"
                  defaultValue=""
                  id="volunteerDuration"
                  required
                >
                  <option value="" hidden></option>
                  <option value="2 week">2 Weeks</option>
                  <option value="1 month">1 Month</option>
                  <option value="2 month">2 Months</option>
                  <option value="3 month">3 Months</option>
                  <option value="6 month">6 Months</option>
                </select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <button
                  className="btn btn-outline-danger w-100 d-flex align-items-center bg-light justify-content-between selectSkillsBtn"
                  type="button"
                  onClick={() => {
                    setShowSkills(!showSkills);
                  }}
                >
                  Select Skills <i className="fa fa-chevron-down"></i>
                </button>
                <div
                  className="skills-dropdown"
                  style={{ display: showSkills ? "block" : "none" }}
                  ref={skillsDropdown}
                >
                  {WebData.skillsList.map((skill, i) => {
                    return (
                      <div key={i} className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="skills_volunteer custom-control-input"
                          onChange={skills_changed}
                          id={`digitalVolunteer-${skill.name}`}
                          name="skills"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={`digitalVolunteer-${skill.name}`}
                        >
                          {skill.name}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <label htmlFor="volunteerCV" className="mb-1">
                  Upload CV*
                </label>
                <div className="custom-file">
                  <input
                    type="file"
                    onChange={change_file}
                    className="form-control"
                    id="volunteerCV"
                    accept=".docx,.doc,.pdf"
                    required
                  />
                </div>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <textarea
                  name="message"
                  placeholder="Message"
                  className="form-control"
                  onChange={formHandler}
                  value={formData ? formData.message : ""}
                ></textarea>
                <div className="wordCount">{wordCount}/200</div>
              </Form.Group>
            </Row>
            <div className="d-flex justify-content-center mt-2 mb-2">
              <button className="btn submitFormBtn">Submit Application</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default DigitalVolunteerForm;
